import { render } from "./FormSubmission.vue?vue&type=template&id=407b3275&scoped=true"
import script from "./FormSubmission.vue?vue&type=script&lang=js"
export * from "./FormSubmission.vue?vue&type=script&lang=js"

import "./FormSubmission.vue?vue&type=style&index=0&id=407b3275&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407b3275"]])

export default __exports__